<template>
  <div>
    <img :src="url" class="ah-animal-symbol"/>
  </div>
</template>

<script>
  import { store } from '../data/store'
  import slugify from '../utils/slugify'

  export default {
    name: 'AnimalSymbol',
    props: {
      animal: Number,
    },
    computed: {
      fileName() {
        const slug = store.species.filter(specie => specie.id === this.animal)[0]?.slug || 'other-animals'
        return `${slug}`
      },
      url() {
        const fn = this.fileName === 'other-animals' ? 'other.png' : `${this.fileName}.svg`
        return `../../../../Static/icons/AH/animal-symbols/${fn}`
      }
    },
  }
</script>

<style lang="scss" scoped>
  .ah-animal-symbol {
    max-width: 24px;
    max-height: 24px;  
    width: 24px;
  }
</style>